import { Component, OnInit, ViewChild } from '@angular/core';
import { EpBtCommunicationService } from 'ep-bt-controls';
import { EpbtFaSortService } from '../../services/epbt-fa-sort.service';
import { EpButtonStyle, EpShellService, EpEventService } from '@epicor/kinetic';
import { EpbtFaFilterService } from '../../services/epbt-fa-filter.service';
import { CustomEvents, SearchPageNames } from 'ep-bt-controls';
import { EpbtFaFilterControlComponent } from '../../controls/epbt-fa-filter-control/epbt-fa-filter-control.component';
import { EpbtFaSortControlComponent } from '../../controls/epbt-fa-sort-control/epbt-fa-sort-control.component';
import { EpbtFaDocumentService } from '../../services/epbt-fa-document.service';
import { EpbtFaQuickPurchaseService } from '../../services/epbt-fa-quick-purchase.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { EpbtFaQuickOrderService } from '../../services/epbt-fa-quick-order.service';
declare var $: any;


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-right-side-bar',
  templateUrl: './epbt-fa-right-side-bar.component.html',
  styleUrls: ['./epbt-fa-right-side-bar.component.scss']
})
export class EpbtFaRightSideBarComponent implements OnInit {
  rightSideModel: any;
  pageName: string;
  EpButtonStyle = EpButtonStyle;
  filterSortForm: FormGroup;
  @ViewChild(EpbtFaFilterControlComponent, { static: false }) filterControlComponent: EpbtFaFilterControlComponent;
  @ViewChild(EpbtFaSortControlComponent, { static: false }) sortControlComponent: EpbtFaSortControlComponent;

  constructor(private communicationService: EpBtCommunicationService, public filterService: EpbtFaFilterService,
    public sortService: EpbtFaSortService, private epShellService: EpShellService, private eventService: EpEventService,
    private faDocumentService: EpbtFaDocumentService, private quickPurchaseService: EpbtFaQuickPurchaseService, private formBuilder: FormBuilder, public quickOrderService: EpbtFaQuickOrderService) {
    this.communicationService.getMessage().subscribe(comp => {
      this.rightSideModel = comp;
      this.updateRightSideBar(comp);
    });
  }

  ngOnInit() {
    // this.filterSortForm.valueChanges.subscribe(
    //   result => {
    //     //   this.saveFormValues();
    //   });
    if (this.quickOrderService.isNewOrder) {
      $('.right-side-panel').closest('.ep-sidebar').addClass('ep-desktop-filter');
      $('.right-side-panel').closest('.ep-sliding-panel').addClass('ep-desktop-filter');
    }

  }

  updateRightSideBar(data: any) {
    this.pageName = data.options;
  }

  onCancelFilter() {
    this.epShellService.collapseSlidingPanel();
  }

  onSubmitFilter(event: any) {
    if (event == 'Apply' || (event && event.keyCode == 13)) {
      if (event != 'Apply' && (event.target.textContent == 'Date range' || event.target.textContent == 'Manual date range' ||
        event.target.textContent == 'Date required' || event.target.placeholder == 'Select Date')) {
        return;
      }
      // console.log(event, "main");
      const currentPageName = this.filterService.pageName == this.sortService.currentPageName ? this.filterService.pageName : '';
      if (this.filterControlComponent) {
        this.filterControlComponent.onFilterSubmit();
        if (!this.filterControlComponent.isDateValid || this.filterControlComponent.filterForm.invalid) {
          return;
        }
      }
      if (this.sortControlComponent) {
        this.sortControlComponent.onSortSubmit();
      }

      switch (currentPageName) {
        case SearchPageNames.CustomerSearch: {
            this.eventService.broadcast(CustomEvents.CustomerSearch, this.sortService.customerSearchValue);
            break;
          }
        case SearchPageNames.CustomerDetailsSearch: { break; }
        case SearchPageNames.ProductSearch: {
            this.eventService.broadcast(CustomEvents.ProductSearch, this.sortService.productSearchValue);
            break;
          }
        case SearchPageNames.ProductDetailsSearch: { break; }
        case SearchPageNames.BinLocationProductSearch: { break; }
        case SearchPageNames.SuppliersSearch: {
            this.eventService.broadcast(CustomEvents.SuppliersSearch, this.sortService.suppliertSearchValue);
            break;
          }
        case SearchPageNames.CustomerAddressSearch: {
            this.eventService.broadcast(CustomEvents.CustomerAddressSearch, this.sortService.customerAddressSearchValue);
            break;
          }
        case SearchPageNames.DashboardContactSearch: {
            this.eventService.broadcast(CustomEvents.DashboardContactSearch, this.sortService.dashboardConatctSearchValue);
            break;
          }
        case SearchPageNames.CustomerContactSearch: {
            this.eventService.broadcast(CustomEvents.CustomerContactSearch, this.sortService.customerConatctSearchValue);
            break;
          }
        case SearchPageNames.DashboardDocumentsSearch: { break; }
        case SearchPageNames.CustomerNotepad: {
            this.eventService.broadcast(CustomEvents.CustomerNotepadSearch, this.filterService.notepadSubject);
            break;
          }
        case SearchPageNames.DashboardNotepadSearch: {
            this.eventService.broadcast(CustomEvents.NotepadDashboardSearch, this.filterService.notepadDashboardSubject);
            break;
          }
        case SearchPageNames.DashboardAddressSearch: {
            this.eventService.broadcast(CustomEvents.DashboardAddressSearch, this.sortService.dashboardAddressSearchValue);
            break;
          }
        case SearchPageNames.CustomerProductsPurchased: {
            this.eventService.broadcast(CustomEvents.CustomerProductsPurchasedSearch, this.filterService.purchasedProductSearch);
            break;
          }
        case SearchPageNames.CustomerOpportunity: {
            this.eventService.broadcast(CustomEvents.CustomerDocumentSearch, this.filterService.opportunitySearchValue);
            break;
          }
        case SearchPageNames.DashboardOpportunitySearch: {
            this.eventService.broadcast(CustomEvents.DashboardOpportunitySearch, this.filterService.dashboardOpportunitySearchValue);
            break;
          }
        case SearchPageNames.CustomerOrders:
        case SearchPageNames.CustomerQuotes:
        case SearchPageNames.CustomerTempOrders:
        case SearchPageNames.CustomerCredit:
        case SearchPageNames.CustomerInvoices:
        case SearchPageNames.DashboardStockTranferSearch:
        case SearchPageNames.DashboardPurchaseOrderSearch:
        case SearchPageNames.DashboardWorkOrderSearch: {
            this.eventService.broadcast(CustomEvents.CustomerDocumentSearch, this.filterControlComponent.searchValue);
            break;
          }
        case SearchPageNames.CustomerStatements: {
            if (this.faDocumentService.fromDashbard) {
              this.eventService.broadcast(CustomEvents.CustomerDocumentSearch, this.filterService.selectedDashboardStatementsCustomer);
            } else {
              this.eventService.broadcast(CustomEvents.CustomerDocumentSearch, 'StatementSort');
            }
            break;
          }
        case SearchPageNames.CustomerCallOffOrders: {
            this.eventService.broadcast(CustomEvents.CustomerDocumentSearch, this.filterService.selectedDashboardCalloffCustomer);
            break;
          }
        default: { break; }
      }
      this.onCancelFilter();
    }
  }
}
